export interface PriceCalculator {
  originalPrice: number;
  basePrice: number;
  plays: number;
  price: number;
  addOnPrice?: number;
  originalAddOnPrice?: number;
}

export default function calculatePrice({
  discount,
  stats,
  variety,
}: {
  discount: number;
  stats: API.MembershipProductStats;
  variety: API.MembershipProductOffer;
  // relatedProducts?: API.MembershipProduct[];
}): PriceCalculator {
  // For season passes, prorate against estimatedPlays (not the raw plays field).
  // For play packs, prorate against plays as before.
  const denominator =
    variety.type === 'season' ? (variety.estimatedPlays ?? variety.plays) : variety.plays;
  const plays =
    variety.auto && denominator - stats.played > 0 ? denominator - stats.played : denominator;
  const startPrice = variety.price || 0;
  const originalPrice = Math.ceil(
    variety.auto ? (((startPrice * 100) / denominator) * plays) / 100 : startPrice,
  );
  let addOnPrice = 0;
  if (variety?.addOn?.price) {
    addOnPrice = Math.ceil(variety?.addOn?.price * (1 - discount) || 0);
  }
  const originalAddOnPrice = variety?.addOn?.price || 0;

  // Per-user flat prices the server stamped onto this offer for a targeted account.
  // Each is the FINAL base price — bypass auto-proration and the global percentage
  // discount so the page shows exactly what checkout will charge; `originalPrice`
  // still holds the catalog price for the strikethrough.
  //   * winback  — NFL win-back price (#1313)
  //   * upgrade  — CFB Weeks 0-1 intro -> full season (#1491): season price minus
  //                what the buyer already paid for their intro.
  // They are mutually exclusive (different products); win-back wins if both appear.
  const winbackPrice = variety?.winback?.price;
  const upgradePrice = variety?.upgrade?.price;
  const flatPrice = winbackPrice ?? upgradePrice;
  let price =
    flatPrice !== undefined && flatPrice !== null
      ? Math.ceil(flatPrice)
      : Math.ceil(originalPrice * (1 - discount));

  const basePrice = price;

  // @todo need to look up all products and check if it has auto on the main item
  // We should probably split this off into something on the API and let it get cached
  if (variety.combos) {
    for (const combo of variety.combos) {
      price += Math.ceil((combo.price || 0) * (1 - discount));
    }
  }

  if (variety.addOn) {
    price += Math.ceil((variety.addOn.price || 0) * (1 - discount));
  }

  return { originalPrice, basePrice, addOnPrice, originalAddOnPrice, plays, price };
}
